import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/swapFund',
            name: 'swapFund',
            component: () => import("./views/swapFund.vue"),
            meta: {
                hasBar: false
            }
        },
        {
            path: '/swapTransactionHistory',
            name: 'swapTransactionHistory',
            component: () => import("./views/swapTransactionHistory.vue"),
            meta: {
                hasBar: false
            }
        },
        {
            path: '/bonusFund',
            name: 'bonusFund',
            component: () => import("./views/bonusFund.vue"),
            meta: {
                hasBar: false
            }
        },
    ];
};